import { render, staticRenderFns } from "./DepartmentReshBanner.vue?vue&type=template&id=96ac6bfe&scoped=true&"
import script from "./DepartmentReshBanner.vue?vue&type=script&lang=js&"
export * from "./DepartmentReshBanner.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentReshBanner.vue?vue&type=style&index=0&id=96ac6bfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ac6bfe",
  null
  
)

export default component.exports